import request from '@/utils/request'


//修改密码
export function userEditPassword(data) {
  return request({
    url: "/ManagerAccount/ManagerUserUpPasswd",
    method: "post",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js